import React from 'react';
import PropTypes from 'prop-types';
import { DataPairLayout } from '@cldf/scotiaweb-canvas-react';
import styles from './DataBalance.scss';

const DataBalance = props => {
  const titleNode = <div>{props.title}</div>;
  const childrenNode = <div>{props.text}</div>;
  const observationNode = <div>{props.observation}</div>;

  return (
    <DataPairLayout
      title={<div className={styles['border--div']}>{titleNode}</div>}
    >
      <div className={styles['border--div']}>{childrenNode}</div>
      <div className={styles['padding--div']}>{observationNode}</div>
    </DataPairLayout>
  );
};
DataBalance.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
};

export { DataBalance };
